module.exports = "<div class=\"clearfix form-control\" style=display:flex;width:100%> <textarea class=\"ui-width textArea\"></textarea> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/textarea-control/textarea-control.wx.html
// module id = 1923
// module chunks = 50